export default __webpack_public_path__ + "static/media/freedrum-logo.cdea68a8.svg";